import { COLLECTION_NAME } from ".";
import { setDocument } from "db/mutations";
import { post } from "db/api";

export const createPlan = async ({ credits, name, price }) => {
  if (!credits || !name || !price) {
    console.error("Faltan datos necesarios para crear el plan");
    return;
  }

  try {
    const response = await post("/create-plan", {
      auto_recurring: {
        currency_id: "CLP",
        frequency: 1,
        frequency_type: "months",
        transaction_amount: price,
      },
      back_url: process.env.MERCADO_PAGO_BACK_URL,
      payment_methods_allowed: {
        payment_methods: [],
        payment_types: [{ id: "credit_card" }],
      },
      reason: `Plan ${name}`,
      setup_fee: 0,
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("Error en la función:", data.error);
      return;
    }

    const { id, ...preapproval } = data;
    // Guardar el plan en la base de datos
    await setDocument(COLLECTION_NAME, id, {
      ...preapproval,
      monthly_credits: credits,
      plan_name: name,
    });
  } catch (error) {
    console.error("Error inesperado:", error.message);
  }
};
